export interface AutoRefreshOption {
  /** Persisted in local storage, so keep ids stable when changing labels or intervals. */
  id: string
  label: string
  shortLabel: string
  /** Minimum time between list refreshes, or `null` to stop live updates. */
  intervalMs: number | null
}

export const AUTO_REFRESH_OPTIONS = [
  {id: '10s', label: 'Every 10 seconds', shortLabel: '10s', intervalMs: 10_000},
  {id: '30s', label: 'Every 30 seconds', shortLabel: '30s', intervalMs: 30_000},
  {id: '1m', label: 'Every minute', shortLabel: '1m', intervalMs: 60_000},
  {id: '5m', label: 'Every 5 minutes', shortLabel: '5m', intervalMs: 300_000},
  {id: 'off', label: 'Off', shortLabel: 'Off', intervalMs: null},
] as const satisfies readonly AutoRefreshOption[]

export type AutoRefreshOptionId = (typeof AUTO_REFRESH_OPTIONS)[number]['id']

const DEFAULT_AUTO_REFRESH_OPTION = AUTO_REFRESH_OPTIONS[1]

export const DEFAULT_AUTO_REFRESH_OPTION_ID: AutoRefreshOptionId = DEFAULT_AUTO_REFRESH_OPTION.id

export const AUTO_REFRESH_STORAGE_KEY = 'actions-workflow-runs-auto-refresh'

export function isAutoRefreshOptionId(value: unknown): value is AutoRefreshOptionId {
  return AUTO_REFRESH_OPTIONS.some(option => option.id === value)
}

export function getAutoRefreshOption(id: AutoRefreshOptionId): AutoRefreshOption {
  return AUTO_REFRESH_OPTIONS.find(option => option.id === id) ?? DEFAULT_AUTO_REFRESH_OPTION
}
